module.exports = __webpack_public_path__ + "img/1.0f17eff9.png";